import React from 'react';
import PropTypes from 'prop-types';


import Loading from '../Loading';
import ColumnCarousel from '../ColumnCarousel';
import { OrderSummary } from '../Order';
import RichText from '../Prismic/RichText';

import { useRecentOrders } from '../../hooks';

import './RecentOrders.scss';

const RecentOrders = ({ title, cta, href, fabletDown, emptyOrdersContent, country: { locale: countryLocale } }) => {

  const { data: orders, loading } = useRecentOrders();

  // DONT MOVE THIS LINE! Ordering matters: when checking values of state set by hooks,
  // you need to make sure that the check happens after the effect that updates it.
  const isOrderEmpty = !loading && orders.length === 0;

  return (
    <section className="recent-orders">
      <div className="container-guttered">
        <ColumnCarousel
          title={title}
          cta={cta}
          href={href}
          enableSlider={fabletDown}
          bypass={loading || isOrderEmpty}>
          {loading && <Loading relative small dark/>}
          {!isOrderEmpty && orders && orders.map(order => (
            <OrderSummary key={`order_${order.number}`} {...order} />
          ))}
          {isOrderEmpty && <RichText fields={emptyOrdersContent} className="recent-orders__content--empty-orders" />}
        </ColumnCarousel>
      </div>
    </section>
  );
};

RecentOrders.propTypes = {
  title: PropTypes.string.isRequired,
  cta: PropTypes.string,
  href: PropTypes.string,
  country: PropTypes.shape({
    locale: PropTypes.string
  }),
  items: PropTypes.array.isRequired,
  emptyOrdersContent: PropTypes.array.isRequired,
  isLoading: PropTypes.bool,
  fabletDown: PropTypes.bool,
};

export default RecentOrders;



// WEBPACK FOOTER //
// ./src/client/js/view/components/RecentOrders/RecentOrders.js